import Excel from 'exceljs';
import filesaver from 'file-saver';
import api from './api'

export const generateExcelFile = async (filename, sheetName, columns, rows) => {
    if(rows.length === 0){
        return Promise.reject({message: "No data found!"});
    }

    const workbook = new Excel.Workbook();
    const worksheet = await workbook.addWorksheet(sheetName);
    worksheet.columns = columns; //@header, @key, @width
    await worksheet.addRows(rows); //array of data based on columns
    const buffer = await workbook.xlsx.writeBuffer();
    const data = new Blob([buffer], { type: 'application/octet-stream' });
    filesaver.saveAs(data, `${filename}.xlsx`)
}

export const loadBrandInfo = () => new Promise(async(resolve, reject) => {
    try {
        let response = await api.get('/edi/brands');
        resolve(response.data)
    } catch (error) {
        reject(error)
    }
})


export const getBrandInfo = (searchTerm, po, brands) => new Promise(async(resolve, reject) => {
    try {
        let category, className, vendorName, netTerm, brandName;

        for(let x in brands){
            let brandinfo = brands[x]
            if(brandinfo.searchTerm === searchTerm){
                className = brandinfo.segment
                vendorName = brandinfo.vendor
                netTerm = brandinfo.netTerm
                brandName =brandinfo.brand
            }
        }
        if(po.slice(0,2) === 'OS' || po.slice(0,2) === 'PB' || po.slice(0,2) === 'AO' || po.slice(0,1) === 'F' || po.indexOf('FBA') === 1){
            category = 'Inventory:ReStock Pro Inventory:Apparel:Inventory in Transit'
            className = 'Corporate'
        }else if(po.slice(0,3) === 'STO' || po.slice(po.length-3, po.length) === 'STO' || po.slice(0,5) === 'STORE' || po.slice(po.length-5,po.length) === 'STORE'){
            category = 'Inventory:ShopKeep Inventory'
            className = 'Corporate'
        }else{
            category = 'Cost of Goods Sold-Purchases'
        }
        resolve({ category, className, vendorName, netTerm, brandName });
    } catch (error) {
        reject(error)
    }
})